"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HotelOfferCell = _interopRequireDefault(require("./HotelOfferCell"));
var _userflow = require("../../utils/userflow");
var _hotel = require("../../proptypes/hotel");
var _utils = require("./utils");
var _excluded = ["offers", "nights", "mealTypes", "selectedNights", "onOfferClicked", "onItemHovered", "visibleColumns", "isHotelOnly", "isWhiteLabel"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Arrow = function Arrow(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 14.9L37 65l-21 50.1"
  }));
};
Arrow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 53 130",
  fill: "none",
  stroke: "#fff",
  strokeWidth: "3",
  strokeLinecap: "round"
};
var HotelOffersTable = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var offers = _ref.offers,
    nights = _ref.nights,
    mealTypes = _ref.mealTypes,
    selectedNights = _ref.selectedNights,
    onOfferClicked = _ref.onOfferClicked,
    onItemHovered = _ref.onItemHovered,
    visibleColumns = _ref.visibleColumns,
    isHotelOnly = _ref.isHotelOnly,
    isWhiteLabel = _ref.isWhiteLabel,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(selectedNights),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    activeColumn = _useState2[0],
    setActiveColumn = _useState2[1];
  var _useState3 = (0, _react.useState)((0, _utils.getVisibleNights)({
      nights: nights,
      count: visibleColumns,
      selectedNights: selectedNights
    })),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    visibleNights = _useState4[0],
    setVisibleNights = _useState4[1];
  var mealTypesCount = mealTypes.length;
  var isPrevAvailable = visibleNights[0] > nights[0];
  var isNextAvailable = visibleNights[visibleNights.length - 1] < nights[nights.length - 1];
  var changeVisibleNights = function changeVisibleNights(value) {
    setVisibleNights(visibleNights.map(function (item) {
      return item + value;
    }));
  };
  var onClickPrev = function onClickPrev() {
    changeVisibleNights(-1);
  };
  var onClickNext = function onClickNext() {
    changeVisibleNights(1);
  };
  return /*#__PURE__*/_react["default"].createElement(StyledTableWrapper, rest, isPrevAvailable && /*#__PURE__*/_react["default"].createElement(StyledPrevArrow, {
    onClick: onClickPrev
  }), isNextAvailable && /*#__PURE__*/_react["default"].createElement(StyledNextArrow, {
    onClick: onClickNext
  }), /*#__PURE__*/_react["default"].createElement(StyledOffersTable, {
    activeColumn: activeColumn,
    onMouseLeave: function onMouseLeave() {
      return setActiveColumn(selectedNights);
    }
  }, mealTypes.map(function (_ref2, idx) {
    var description = _ref2.description,
      id = _ref2.id;
    var lastRowIdx = mealTypesCount - 1;
    var isLast = idx === lastRowIdx;
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: id
    }, /*#__PURE__*/_react["default"].createElement(Row, null, visibleNights.map(function (numOfNights) {
      var isActive = numOfNights === activeColumn;
      return /*#__PURE__*/_react["default"].createElement(StyledOfferWrapper, {
        key: id + numOfNights
      }, /*#__PURE__*/_react["default"].createElement(StyledOffer, {
        onOfferClicked: onOfferClicked,
        onItemHovered: setActiveColumn,
        showNights: idx === 0,
        isActive: isActive,
        mealType: description,
        offers: (0, _userflow.getOffersByNights)(offers[id], numOfNights),
        startDate: (0, _userflow.getOffersStartDate)(offers[id][0]),
        nightsCount: numOfNights,
        isLast: isLast,
        isHotelOnly: isHotelOnly,
        isWhiteLabel: isWhiteLabel
      }));
    })), idx < lastRowIdx && /*#__PURE__*/_react["default"].createElement(StyledSeparator, {
      width: visibleNights.length
    }));
  })));
});
HotelOffersTable.displayName = 'HotelOffersTable';
HotelOffersTable.propTypes = {
  className: _propTypes["default"].string,
  onOfferClicked: _propTypes["default"].func.isRequired,
  onItemHovered: _propTypes["default"].func,
  mealTypes: _propTypes["default"].arrayOf(_hotel.MealTypePropTypes.isRequired).isRequired,
  selectedNights: _propTypes["default"].number.isRequired,
  nights: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  isActive: _propTypes["default"].bool,
  offers: _propTypes["default"].objectOf(_propTypes["default"].arrayOf(_hotel.HotelOfferPropTypes).isRequired).isRequired,
  visibleColumns: _propTypes["default"].number.isRequired,
  isWhiteLabel: _propTypes["default"].bool
};
HotelOffersTable.defaultProps = {
  className: '',
  isActive: false,
  onItemHovered: undefined
};
var StyledTableWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersTable__StyledTableWrapper",
  componentId: "sc-60txa-0"
})(["position:relative;"]);
var StyledArrow = (0, _styledComponents["default"])(Arrow).withConfig({
  displayName: "HotelOffersTable__StyledArrow",
  componentId: "sc-60txa-1"
})(["position:absolute;cursor:pointer;width:18px;height:36px;top:5px;path{stroke:", ";stroke-width:6px;}"], function (props) {
  return props.theme.colors.greyLight;
});
var StyledPrevArrow = (0, _styledComponents["default"])(StyledArrow).withConfig({
  displayName: "HotelOffersTable__StyledPrevArrow",
  componentId: "sc-60txa-2"
})(["transform:rotate(180deg);left:0;"]);
var StyledNextArrow = (0, _styledComponents["default"])(StyledArrow).withConfig({
  displayName: "HotelOffersTable__StyledNextArrow",
  componentId: "sc-60txa-3"
})(["transform:none;right:0;"]);
var StyledNight = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersTable__StyledNight",
  componentId: "sc-60txa-4"
})(["color:", ";text-align:center;font-size:18px;padding-top:10px;"], function (props) {
  return props.theme.colors.greyLight;
});
var StyledOffersTable = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersTable__StyledOffersTable",
  componentId: "sc-60txa-5"
})(["display:table;height:100%;*[data-nights='", "']{background:rgba(248,231,28,0.2);", "{color:", ";}}"], function (props) {
  return props.activeColumn;
}, StyledNight, function (props) {
  return props.theme.colors.blackBase;
});
var StyledCell = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersTable__StyledCell",
  componentId: "sc-60txa-6"
})(["display:table-cell;padding:0 5px;padding-top:2px;min-width:150px;max-width:150px;padding-bottom:10px;"]);
var Row = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersTable__Row",
  componentId: "sc-60txa-7"
})(["display:table-row;&:last-child{min-height:100%;height:100%;", "{padding-bottom:50px;}}"], StyledCell);
var StyledOfferWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersTable__StyledOfferWrapper",
  componentId: "sc-60txa-8"
})(["display:table-cell;min-width:150px;min-height:100%;"]);
var StyledOffer = (0, _styledComponents["default"])(_HotelOfferCell["default"]).withConfig({
  displayName: "HotelOffersTable__StyledOffer",
  componentId: "sc-60txa-9"
})(["height:100%;min-width:150px;max-width:150px;"]);
var StyledSeparator = _styledComponents["default"].div.withConfig({
  displayName: "HotelOffersTable__StyledSeparator",
  componentId: "sc-60txa-10"
})(["margin:0 10px;width:calc(", ");height:1px;background:#d6d5c9;"], function (props) {
  return "".concat(props.width * 100, "% - 20px");
});
var _default = exports["default"] = HotelOffersTable;